(() => {
  'use strict';
  const video = document.getElementById('material-demo');
  const play = document.getElementById('material-play');
  const replay = document.getElementById('material-replay');
  if(!video || !play || !replay) return;
  const source = video.querySelector('source');
  const chapters = [...document.querySelectorAll('[data-home-material-time]')];
  let generation = 0;
  let pendingSeek = null;
  const status = document.createElement('div');
  status.className = 'film-context';
  status.hidden = true;
  status.setAttribute('role','status');
  const message = document.createElement('p');
  message.textContent = 'The video could not play. Try again or open it separately.';
  const actions = document.createElement('div');
  actions.className = 'film-caption';
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = 'Try again';
  const openVideo = document.createElement('a');
  openVideo.href = source?.src || video.currentSrc || video.src;
  openVideo.target = '_blank';
  openVideo.rel = 'noopener';
  openVideo.textContent = 'Open video ↗';
  openVideo.setAttribute('aria-label','Open the material video in a new tab');
  openVideo.style.textDecoration = 'underline';
  actions.append(retry,openVideo);
  status.append(message,actions);
  video.closest('.material-film')?.append(status);

  function showFailure() {
    play.hidden = true;
    status.hidden = false;
  }
  function cancelSeek() {
    generation += 1;
    if(pendingSeek)video.removeEventListener('loadedmetadata',pendingSeek);
    pendingSeek = null;
  }
  function pause() {
    cancelSeek();
    video.pause();
  }
  async function start(fromBeginning=false,reload=false,time=null) {
    cancelSeek();
    const request = generation;
    try {
      if(reload || video.error)video.load();
      const target = time ?? ((fromBeginning || video.ended) ? 0 : null);
      if(target !== null && video.readyState < 1) {
        pendingSeek = () => {
          if(request !== generation)return;
          pendingSeek = null;
          if(!document.hidden)start(false,false,target);
        };
        video.addEventListener('loadedmetadata',pendingSeek,{once:true});
        video.load();
        return;
      }
      if(target !== null)video.currentTime=target;
      video.playbackRate=1;
      await video.play();
    } catch(error) {
      // Leaving the section or opening a reading panel can deliberately pause playback.
      if(request === generation && error.name !== 'AbortError')showFailure();
    }
  }
  play.addEventListener('click',()=>start());
  replay.addEventListener('click',()=>start(true));
  retry.addEventListener('click',()=>start(true,true));
  chapters.forEach(button=>button.addEventListener('click',()=>start(false,false,Number(button.dataset.homeMaterialTime))));
  video.addEventListener('timeupdate',()=>{
    const active=video.currentTime>=12.7?'12.7':video.currentTime>=5.4?'5.4':null;
    chapters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.homeMaterialTime===active)));
  });
  video.addEventListener('play',()=>{play.hidden=true;});
  video.addEventListener('playing',()=>{
    if(status.contains(document.activeElement))video.focus({preventScroll:true});
    status.hidden=true;
  });
  video.addEventListener('ended',()=>{play.hidden=false;play.querySelector('strong').textContent='Watch again';});
  const fail=()=>{cancelSeek();showFailure();};
  video.addEventListener('error',fail);
  source?.addEventListener('error',fail);
  // The demonstration starts only on request and pauses when it leaves view.
  new IntersectionObserver(entries=>{for(const e of entries)if(!e.isIntersecting)pause();},{threshold:0}).observe(video);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)pause();});
  document.addEventListener('px:home-reader',pause);
  window.addEventListener('pagehide',pause);
})();
